import React from "react";
import ExperienceTimelineContent from "./experienceTimelineContent";
import INFO from "../../data/user";

import "./styles/experienceTimeline.css";

const ExperienceTimeline = () => {
	return (
		<div className="timeline-container">
			<div className="timeline-line" />
			{INFO.experienceList.map((experience, index) => (
				<div className="timeline-entry-container" key={index}>
					<div className="timeline-entry-node" />
					<ExperienceTimelineContent
						title={experience.title}
						company_url={experience.company_url}
						date={experience.date}
						description={experience.description}
					/>
				</div>
			))}
		</div>
	);
};

export default ExperienceTimeline;
